module.exports = "/_next/static/images/perks-collectible-c97106f3f324b8a5804671df9b51b8f7.png";